<template>
  <div class="insurance-variants-section">
      <ul class="insurance-variants-section__cards">
        <li
          class="insurance-variants-section__item"
          v-for="(card, idx) in cards"
          :key="idx"
        >
          <InsuranceTariffCard
            class="insurance-variants-section__item-card"
            :tariff="card.tariff"
            :tariff-go="tariffGo"
            :use-titul="useTitul"
            :title="card.title"
            :subtitle="card.subtitle"
            :price="card.price"
            :card-price="card.cardPrice"
            :card-tooltip="card.cardTooltip"
            :is-selected="card.isSelected"
            :submitText="card.isSelected ? 'Выбрано' : 'Выбрать'"
            :titul-prem="getTitulPrice"
            @tariff-chosen="handleTariff"
            @change-tariff-go="changeTariffGo"
            @change-use-titul="changeUseTitul"
          />
        </li>
      </ul>
  </div>
</template>

<script>
import { INSURANCE_CARDS } from '@/consts';
import { commafy } from '@/utils/string-helpers';
import { calculatorEipoteka } from "@/api/routes/calculator-eipoteka";
import InsuranceTariffCard from '@/components/ui/InsuranceTariffCard';

export default {
  name: 'TheInsuranceVariants',
  components: {
    InsuranceTariffCard,
  },
  props: {
    tariffsSum: Object,
    formData: Object,
    premSumGo: Number,
    tariffGo: Number | null,
    useTitul: Boolean,
  },
  data() {
    return {
      cards: null,
      titulSum: 0,
    }
  },
  watch: {
    tariffsSum: function(newVal, oldVal) {
      this.handleCards();
    },
    premSumGo: function(newVal, oldVal) {
      this.handleCards();
    },
    useTitul: function(newVal, oldVal) {
      this.handleCards();
    },
  },
  computed: {
    getTitulPrice() {
      return this.tariffsSum?.sumPremTitul ?? 0;
    }
  },
  methods: {
    handleTariff(tariff, isSelected) {
      this.cards = this.cards.map((card) => ({
        ...card,
        isSelected: (tariff === card.tariff) ? isSelected : card.isSelected,
      }));

      this.$emit('tariff-chosen', this.cards)
    },
    changeTariffGo(value) {
      this.$emit('change-tariff-go', value)
    },
    changeUseTitul(value) {
      this.$emit('change-use-titul', value)
    },
    handleCards()
    {
      const _this = this;
      let defaultCards = INSURANCE_CARDS;

      if (this.sessionData && this.sessionData.stepTwo && this.sessionData.stepTwo.tariffs) {
        defaultCards = defaultCards.map((card) => ({
          ...card,
          isSelected: this.sessionData.stepTwo.tariffs[card.tariff],
        }));
      }

      defaultCards = defaultCards.filter((card) => {
        return card.tariff === 'property' && this.tariffsSum.sumPremProperty
          || card.tariff === 'life' && this.tariffsSum.sumPremLife;
      });

      const { sumPremProperty, sumPremLife } = this.tariffsSum

      defaultCards.map((card) => {
        card.price = commafy(this.formData.credit_balance);

        if (card.tariff === 'property' && sumPremProperty) {
          card.sumPrem = sumPremProperty + _this.premSumGo;
          card.cardPrice = sumPremProperty + _this.premSumGo;
        }

        if (card.tariff === 'property' && _this.useTitul) {
          card.sumPrem = card.sumPrem + _this.tariffsSum?.sumPremTitul ?? 0;
          card.cardPrice = card.cardPrice + _this.tariffsSum?.sumPremTitul ?? 0;
        }

        if (card.tariff === 'life' && sumPremLife) {
          card.sumPrem = sumPremLife;
          card.cardPrice = sumPremLife;
        }
      });

      if (defaultCards.length === 1) {
        defaultCards = defaultCards.map((card) => {
          return {
            ...card,
            isSelected: true,
          }
        })
      }

      if (this.cards && this.cards.length) {
        defaultCards.forEach((newCard, newIndex) => {
          this.cards.forEach((card) => {
            if (card.tariff === newCard.tariff) {
              defaultCards[newIndex].isSelected = card.isSelected;
            }
          });
        });
      }

      this.cards = defaultCards;
      this.$emit('mounted', this.cards);
    }
  },
  async mounted() {
    this.sessionData = await calculatorEipoteka('getSessionData');
    this.handleCards();
  },
}
</script>

<style scoped lang="scss">
.insurance-variants-section {
  &__cards {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media #{$screen-big} {
      flex-direction: row;
    }

    @media #{$screen-small} {
      flex-direction: column;
    }
  }

  &__item {
    @media #{$screen-big} {
      @include flex-width-two-in-row(24px);
    }

    @media #{$screen-small} {
      width: auto;
    }

    &:not(:last-child) {
      margin-bottom: rem(24);

      @media #{$screen-big} {
        margin-bottom: 0;
      }

      @media #{$screen-small} {
        margin-bottom: rem(24);
      }
    }

    &-card {
      height: 100%;
    }
  }
}
</style>
